import styled from 'styled-components';
import { TooltipProps } from 'antd';
import Checkbox from 'components/checkbox/Checkbox';
import Tooltip from 'components/tooltip';
import { ACC_OWNER, TEAM_MANAGER } from 'constants/roles';
import { UserInvites } from 'contexts/users/types';
import { AvatarLetter } from 'components/avatar';

const SuggestionContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f2f2f7;
  gap: 15px;

  .user-suggestion__checkbox > span:not(.ant-checkbox) {
    display: none;
  }

  > .user-data {
    font-size: 14px;
    font-weight: 400;
    > h4 {
      margin: 0;
    }
    > p {
      margin: 0;
      color: ${({ theme }) => theme.default.colors.fonts.darkGray};
    }
  }
`;

interface IUserSuggestion extends UserInvites {
  onCheck({ id, uaa_data, email, checked, has_license, is_manager, is_account_owner, teams }): void;
  checked: boolean;
  disabled?: boolean;
  checkboxTooltip?: React.ReactNode;
  checkboxTooltipPlacement?: TooltipProps['placement'];
}

const UserSuggestion: React.FC<IUserSuggestion> = ({
  id,
  license,
  uaa_data,
  onCheck,
  checked,
  disabled,
  checkboxTooltip,
  checkboxTooltipPlacement,
  role,
  teams,
}) => {
  const profileData = uaa_data?.profile?.data;
  const fullName = `${profileData?.first_name ?? ''} ${profileData?.last_name ?? ''}`.trim();
  const isAccountOwner = uaa_data
    ? uaa_data?.roles?.data?.find((role) => role.name === ACC_OWNER) !== undefined
    : role === ACC_OWNER;
  const checkbox = (
    <Checkbox
      id={`user-${id}`}
      name={`user-${id}`}
      className="user-suggestion__checkbox"
      onChange={({ target }) =>
        onCheck({
          id,
          uaa_data,
          has_license: !!license,
          is_manager: role === TEAM_MANAGER,
          email: uaa_data?.email,
          is_account_owner: isAccountOwner,
          checked: target.checked,
          teams: teams,
        })
      }
      checked={checked}
      controlled
      disabled={disabled}
    />
  );
  return (
    <SuggestionContainer>
      {checkboxTooltip ? (
        <Tooltip
          placement={checkboxTooltipPlacement ?? 'right'}
          overlayInnerStyle={{ textAlign: 'center' }}
          title={checkboxTooltip}
        >
          <span style={{ display: 'inline-flex' }}>{checkbox}</span>
        </Tooltip>
      ) : (
        checkbox
      )}
      <AvatarLetter
        avatar={profileData?.avatar}
        name={fullName || uaa_data?.email || ''}
        email={uaa_data?.email}
      />
      <div className={'user-data'}>
        <h4>{fullName || uaa_data?.email}</h4>
        <p>{uaa_data?.email}</p>
      </div>
    </SuggestionContainer>
  );
};

export default UserSuggestion;
